import { API_CALL_FINISHED, COUNTED_API_CALL_FINISHED } from './loading-spinner.actions';

const initialState = {
  numberOfCallsInProgress: 0,
  isCallFinished: true,
};

export const loadingSpinnerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case API_CALL_FINISHED:
      return {
        ...state,
        isCallFinished: payload,
      };
    case COUNTED_API_CALL_FINISHED:
      return {
        ...state,
        numberOfCallsInProgress: payload
          ? state.numberOfCallsInProgress + 1
          : state.numberOfCallsInProgress - 1,
      };
    default:
      return state;
  }
};
